 
import React, { useRef } from "react";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { LoadState } from "../../constants/enums";
import { PageContainer } from "../../components/container/PageContainer";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  Snackbar,
  Alert,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useDispatchWrapper } from "../../hooks";

import { useFormik } from "formik";
import { StandadCard } from "../../components/Cards";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../components/formsComponents";
import { Editor } from "../../components/Editor/Editor";

// import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";

// import { COUNTRY_LIST } from "../../constants/constants";
import { PreviewTemplate } from "../../components/Preview/PreviewTemplate";
// import { FileUpload } from "../../components/FileUpload/components/FileUpload";
import WhatsappBgImg from "../../assets/whatsapp_bg_img.jpg";
import { useNavigate, useParams } from "react-router-dom";

import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";

import {
  IQuickReplyTemplateData,
} from "../../redux/quickReplyTemplates/quickReplyTemplate.types";
import {
  clearQuickReplyTemplateState,
  fetchQuickReplyTemplateAsync,
  upsertQuickReplyTemplate,
} from "../../redux/quickReplyTemplates/quickReplyTemplateAction";

interface IManageQuickReplyTemplateProps {
  onSaveSuccess: (templateData: IQuickReplyTemplateData) => void;
  templateName?: string;
  templateData?: IQuickReplyTemplateData;
  fromRightPanel?: boolean;
  isFromRecommendedFromRightpanel?: boolean;
  recommendedTemplateDataFromRightpanel?: IQuickReplyTemplateData;
}

export const ManageQuickReplyTemplate: React.FC<
  IManageQuickReplyTemplateProps
> = ({
  templateName,
  templateData,
  onSaveSuccess,
  fromRightPanel = false,
  isFromRecommendedFromRightpanel = false,
  recommendedTemplateDataFromRightpanel = null,
}) => {
  // const CompanyOutletContext = useBillingCompanyContext();
  const navigate = useNavigate();
  const { quickReplyTemplateName } = useParams();
  const isUpdate = quickReplyTemplateName || templateName ? true : false;

  const [submitAttempted, setSubmitAttempted] = React.useState(false);
  const [showError, setShowError] = React.useState<Partial<
    Record<keyof IQuickReplyTemplateData, string>
  > | null>(null);

  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/quick-reply-templates",
      title: "Quick Reply Templates",
    },
    {
      title:
        templateName || quickReplyTemplateName
          ? "Edit Quick Reply Template"
          : "Create Quick Reply Template",
    },
  ];

  const {
    data: quickReplyTemplateData,
    loading: quickReplyTemplateDataLoading,
    error: quickReplyTemplateDataError,
  } = useSelector(
    (storeState: IStoreState) =>
      storeState.quickReplyTemplate.quickReplyTemplateData
  );

  const [bodyCharCount, setBodyCharCount] = React.useState(0);

  const {
    values,
    errors,
    setFieldValue,
    setValues,
    handleChange,
    handleSubmit,
    validateForm,
  } = useFormik({
    initialValues: templateData ? templateData : quickReplyTemplateData,

    validate: (values) => {
      const errors: any = {};
      if (!values.text) {
        errors.text = "Message is required!.";
      }

      if (!values.name) {
        errors.name = "Template Name is required!.";
      }

      return errors;
    },
    onSubmit: (values) => {
      setSubmitAttempted(true);
      const updatedValues: IQuickReplyTemplateData = {
        ...values,
        // company_outlet_uuid: CompanyOutletContext.comapny.company_outlet_uuid,
        text: convertHtmlToMarkdown(values.text),
      };

      dispatch(
        upsertQuickReplyTemplate(
          updatedValues as IQuickReplyTemplateData,
          (isSuccess, templateData) => {
            if (isSuccess) {
              if (fromRightPanel) {
                onSaveSuccess(templateData as IQuickReplyTemplateData);
              } else {
                navigate("/quick-reply-templates");
              }
            }
          }
        )
      );
    },
  });

  const handleGlobalSaveClick = async () => {
    const formErrors = await validateForm();
    setSubmitAttempted(true);
    setShowError(
      formErrors as Partial<Record<keyof IQuickReplyTemplateData, string>>
    );
    if (
      Object.keys(
        formErrors as Partial<Record<keyof IQuickReplyTemplateData, string>>
      ).length > 0
    ) {
      return;
    }
    setShowError(null); 
    handleSubmit();
  };
  const editorRef = useRef<{
    insertTextAtCursor: (text: string) => void;
  } | null>(null);

  const dispatch = useDispatchWrapper();

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .replace(/[^a-z0-9_]/g, ""); // Remove any other special characters

    setFieldValue("name", value);
  };

  const handleBodyChange = (html: string) => {
    const markdown = convertHtmlToMarkdown(html);
    setBodyCharCount(markdown.length);

    setFieldValue("text", html);
  };

  React.useEffect(() => {
    if (templateName) {
      dispatch(
        fetchQuickReplyTemplateAsync(
          templateName,
          // CompanyOutletContext.comapny.company_outlet_uuid
        )
      );
    }

    return () => {
      dispatch(clearQuickReplyTemplateState());
    };
  }, [templateName]);

  function convertHtmlToMarkdown(html: string) {
    let orderCount = 0;

    const markdown = html
      // Bold → *text*
      .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
      // Italic → _text_
      .replace(/<em>(.*?)<\/em>/gi, "_$1_")
      // Paragraphs → keep double newlines
      .replace(/<p>(.*?)<\/p>/gi, (m, p1) => `${p1.trim()}\n\n`)
      // Line breaks → single newline
      .replace(/<br\s*\/?>/gi, "\n")
      // List items
      .replace(/<li[^>]*>(.*?)<\/li>/gi, (match, content, index, fullText) => {
        const textBeforeLi = fullText.substring(0, fullText.indexOf(match));
        const lastListTag = textBeforeLi.lastIndexOf("<ol");
        const isOrderedList =
          lastListTag !== -1 &&
          textBeforeLi.substring(lastListTag).indexOf("</ol") === -1;

        if (isOrderedList) {
          orderCount++;
          return `${orderCount}. ${content.trim()}\n`;
        }
        return `• ${content.trim()}\n`;
      })
      // Remove list wrappers
      .replace(/<\/?[uo]l[^>]*>/gi, "\n")
      // Images → alt text
      .replace(/<img[^>]*alt="([^"]*)"[^>]*>/gi, "$1")
      // Strip remaining tags
      .replace(/<\/?[^>]+(>|$)/g, "")
      // Decode &nbsp;
      .replace(/&nbsp;/g, " ")
      // Collapse *3+* newlines into 2 (to preserve blank lines between paragraphs)
      .replace(/\n{3,}/g, "\n\n")
      .trim();

    return markdown;
  }

  React.useEffect(() => {
    if (isUpdate) {
      dispatch(
        fetchQuickReplyTemplateAsync(
          quickReplyTemplateName,
          // CompanyOutletContext.comapny.company_outlet_uuid,
          ""
        )
      );
    }
  }, [quickReplyTemplateName, dispatch]);

  return (
    <>
      <PageLoader
        loading={quickReplyTemplateDataLoading === LoadState.InProgress}
        error={
          quickReplyTemplateDataError
            ? {
                message:
                  quickReplyTemplateDataError || "Error loading template",
              }
            : null
        }
      >
        <PageContainer
          title={
            templateName
              ? "Edit Quick Reply Template"
              : "Create Quick Reply Template"
          }
          description="this is inner page"
        >
          {!fromRightPanel && (
            <Breadcrumb title="Create Quick Reply Template" items={BCrumb} />
          )}
          <StandadCard
            renderWithoutCard={fromRightPanel}
            heading={
              templateName || quickReplyTemplateName
                ? "Edit Quick Reply Template"
                : !fromRightPanel
                ? "Create Quick Reply Template"
                : ""
            }
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <CustomFormLabel>Name</CustomFormLabel>
                  <CustomTextField
                    fullWidth
                    name="name"
                    value={values.name}
                    // onChange={handleChange}
                    onChange={handleNameChange}
                    error={submitAttempted && errors.name ? true : false}
                    helperText={submitAttempted ? errors.name : ""}
                    placeholder="(eg: my_template_name, lowercase letters, and underscores only)"
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} mt={2}>
                      <Typography variant="h3" fontWeight={600}>
                        Body
                      </Typography>
                      <Editor
                        content={values.text}
                        // ref={editorRef}
                        // height={300}
                        // isFromQuickReply={true}
                        onChange={handleBodyChange}
                      />
                      <Stack>
                        <Stack direction={"row"} justifyContent={"start"}>
                          <Typography
                            variant="caption"
                            color={
                              bodyCharCount > 1024 ? "error" : "textSecondary"
                            }
                            sx={{ mr: 2 }}
                          >
                            {bodyCharCount}/1024 characters
                            {bodyCharCount > 1024 && " - Exceeds limit!"}
                          </Typography>
                          {submitAttempted &&
                            errors.body &&
                            errors.body.text && (
                              <Typography
                                variant="caption"
                                color="error"
                                display="block"
                              >
                                {submitAttempted ? errors.body.text : ""}
                              </Typography>
                            )}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={4} mt={2}>
                  <Typography variant="h3" fontWeight={600}>
                    Preview Template
                  </Typography>
                  <Box
                    p={2}
                    pt={4}
                    borderRadius={2}
                    sx={{
                      backgroundImage: `url(${WhatsappBgImg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      minHeight: "300px",
                    }}
                  >
                    <PreviewTemplate
                      template={values}
                      loading={quickReplyTemplateDataLoading}
                      isFromQuickReply={true}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Stack
                mt={3}
                direction={"row"}
                position={fromRightPanel ? "sticky" : "fixed"}
                bottom={fromRightPanel ? 0 : 20}
                left={fromRightPanel ? undefined : 0}
                right={fromRightPanel ? undefined : 20}
                justifyContent={"right"}
                spacing={2}
                sx={{
                  ...(fromRightPanel && {
                    backgroundColor: "background.paper",
                    py: 2,
                    zIndex: 1,
                  }),
                }}
              >
                <Button
                  variant="contained"
                  type="button"
                  disabled={submitAttempted}
                  onClick={handleGlobalSaveClick}
                >
                  Save
                </Button>
              </Stack>
            </form>
          </StandadCard>
        </PageContainer>
      </PageLoader>
      <Snackbar
        open={!!showError}
        autoHideDuration={5000}
        onClose={() => setShowError(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 9999 }}
      >
        <Alert
          onClose={() => setShowError(null)}
          severity="error"
          sx={{ width: 400 }}
        >
          <List dense sx={{ p: 0 }}>
            {showError &&
              Object.values(showError).map((msg, index) => (
                <ListItem key={index} sx={{ py: 0 }}>
                  <ListItemText primary={String(msg)} />
                </ListItem>
              ))}
          </List>
        </Alert>
      </Snackbar>
    </>
  );
};
